import StoredLayout from 'layouts/StoredLayout';
import LoadingSpinner from 'cyder/loadingSpinner/LoadingSpinner';
import { Row as FlexRow, Col as FlexCol } from 'react-flexbox-grid';
import DialogModal from 'cyder/modals/DialogModal';
import React from 'react';
import { connect } from 'react-redux';
import history from '../../../../history';
import { Input, Row, Col, Form, Button, FormGroup, Label } from 'reactstrap';
import CyderFileUpload from 'cyder/forms/CyderFileUpload';
import { save, update, remove, load } from 'actions/staff/election/nominee/action.js';

import 'css/forms/default-forms.css';

class AddPage extends React.Component {
    constructor(props) {
        super(props);

        this.onUploadFail = this.onUploadFail.bind(this);
        this.onUploadSuccess = this.onUploadSuccess.bind(this);

        this.electionIdChange = this.electionIdChange.bind(this);

        this.descriptionChange = this.descriptionChange.bind(this);

        this.organizationNameChange = this.organizationNameChange.bind(this);

        this.fullNameChange = this.fullNameChange.bind(this);

        this.categoryChange = this.categoryChange.bind(this);

        this.save = this.save.bind(this);
        this.remove = this.remove.bind(this);
        this.removeConfirm = this.removeConfirm.bind(this);
        this.back = this.back.bind(this);

        this.modalToggle = this.modalToggle.bind(this);
        this.showModal = this.showModal.bind(this);
        this.showLoading = this.showLoading.bind(this);
        this.modalAction = this.modalAction.bind(this);
        this.negativeModalAction = this.negativeModalAction.bind(this);

        this.state = {
            loading: false,
            data: {
                cvAndManifestoPdf: '',
                cvAndManifestoPdfName: '',

                electionId: this.props.match.params.electionid,

                description: '',

                organizationName: '',

                fullName: '',

                category: this.props.match.params.type,
            },
            modal: {
                showModal: false,
                modalMessage: '',
                modalHeader: '',
                positiveButtonHide: true,
                negativeButtonHide: true,
                type: 'save',
            },
        };
    }
    onUploadSuccess(file) {
        var data = this.state.data;
        data.cvAndManifestoPdf = file.id;
        data.cvAndManifestoPdfName = file.filename;
        this.setState({
            data,
        });
    }
    onUploadFail(error) {}
    back() {
        history.replace(`/staff/elections/view/${this.props.match.params.electionid}/nominee/${this.props.match.params.type}`);
    }
    modalAction() {
        if (this.state.modal.type === 'deleteConfirm') {
            this.remove();
        }
    }
    negativeModalAction() {
        this.modalToggle();
    }
    showLoading(show) {
        this.setState({
            loading: show,
        });
    }
    modalToggle() {
        var modal = this.state.modal;
        modal.showModal = !modal.showModal;
        this.setState({
            modal,
        });
    }
    showModal(header, message, type, positiveButtonHide, negativeButtonHide) {
        var modal = this.state.modal;
        modal.showModal = true;
        modal.modalHeader = header;
        modal.type = type;
        modal.positiveButtonHide = positiveButtonHide;
        modal.negativeButtonHide = negativeButtonHide;
        modal.modalMessage = message;
        this.setState({
            modal,
        });
    }
    componentDidMount() {
        this.showLoading(true);
        var id = null;
        try {
            id = this.props.match.params.id;
        } catch (e) {}
        if (id != null && id > 0) {
            this.props
                .load(id)
                .then(res => {
                    if (res.error || res.data == null || res.data.id == null) {
                        this.showModal('Error', res.message, 'load', true, true);
                    } else {
                        this.setState({
                            data: res.data,
                        });
                    }
                    this.showLoading(false);
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'load', true, true);
                });
        } else {
            this.setState({
                data: {
                    cvAndManifestoPdf: '',

                    electionId: '',

                    description: '',

                    organizationName: '',

                    fullName: '',

                    category: '',
                },
            });
            this.showLoading(false);
        }
    }
    prepareDataBeforeSave(data) {
        var newData = data;
        return newData;
    }
    save() {
        var data = this.prepareDataBeforeSave(this.state.data);
        data.category = this.props.match.params.type;
        data.electionId = this.props.match.params.electionid;
        this.showLoading(true);
        if (data.id == null || data.id === 0 || data.id === '') {
            this.props
                .save(data)
                .then(res => {
                    this.showLoading(false);
                    if (res.error) {
                        this.showModal('Error', res.message, 'save', true, true);
                    } else {
                        history.replace(
                            `/staff/elections/view/${this.props.match.params.electionid}/nominee/${this.props.match.params.type}`,
                        );
                    }
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'save', true, true);
                });
        } else {
            this.props
                .update(data)
                .then(res => {
                    this.showLoading(false);
                    if (res.error) {
                        this.showModal('Error', res.message);
                    } else {
                        history.replace(
                            `/staff/elections/view/${this.props.match.params.electionid}/nominee/${this.props.match.params.type}`,
                            'update',
                            true,
                            true,
                        );
                    }
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'update', true, true);
                });
        }
    }
    removeConfirm() {
        this.showModal('Confirmation', 'Are you sure you want to delete this record?', 'deleteConfirm', false, false);
    }
    remove() {
        var data = this.state.data;
        this.props
            .remove(data.id)
            .then(res => {
                history.replace(`/staff/elections/view/${this.props.match.params.electionid}/nominee/${this.props.match.params.type}`);
            })
            .catch(error => {
                this.showModal('Error', error.message, 'delete', true, true);
            });
    }
    cvAndManifestoPdfChange(e) {
        var data = this.state.data;
        data.cvAndManifestoPdf = e.target.value;
        this.setState({ data });
    }

    electionIdChange(e) {
        var data = this.state.data;
        data.electionId = e.target.value;
        this.setState({ data });
    }

    descriptionChange(e) {
        var data = this.state.data;
        data.description = e.target.value;
        this.setState({ data });
    }

    organizationNameChange(e) {
        var data = this.state.data;
        data.organizationName = e.target.value;
        this.setState({ data });
    }

    fullNameChange(e) {
        var data = this.state.data;
        data.fullName = e.target.value;
        this.setState({ data });
    }

    categoryChange(e) {
        var data = this.state.data;
        data.category = e.target.value;
        this.setState({ data });
    }

    render() {
        return this.state.loading ? (
            <LoadingSpinner />
        ) : (
            <div className="page-widget">
                <DialogModal
                    modalAction={this.modalAction}
                    negativeButtonAction={this.negativeModalAction}
                    actionToggleExternal={this.modalToggle}
                    modalOpen={this.state.modal.showModal}
                    positiveButtonHide={this.state.modal.positiveButtonHide}
                    negativeButtonHide={this.state.modal.negativeButtonHide}
                    modalBody={this.state.modal.modalMessage}
                    modalHeader={this.state.modal.modalHeader}
                />
                <Form style={{ paddingBottom: '20px' }}>
                    <Row className="mb-2">
                        <Col xs={12} className="d-flex mb-4">
                            <Button className="primary-btn-style-outline" onClick={this.back}>
                                <i className="material-icons align-text-bottom">chevron_left</i>
                                &nbsp; Back
                            </Button>
                        </Col>
                    </Row>
                    <hr />
                    <Row className="mb-2">
                        <Col xs={12}>
                            <FormGroup>
                                <Label for="fullName">Full Name</Label>{' '}
                                <Input
                                    type="text"
                                    name="fullName"
                                    id="fullName"
                                    value={this.state.data.fullName}
                                    placeholder=""
                                    onChange={this.fullNameChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={12}>
                            <FormGroup>
                                <Label for="organizationName">Organisation Name</Label>{' '}
                                <Input
                                    type="text"
                                    name="organizationName"
                                    id="organizationName"
                                    value={this.state.data.organizationName}
                                    placeholder=""
                                    onChange={this.organizationNameChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={12}>
                            <FormGroup>
                                <Label for="description">Description</Label>{' '}
                                <Input
                                    type="text"
                                    name="description"
                                    id="description"
                                    value={this.state.data.description}
                                    placeholder=""
                                    onChange={this.descriptionChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="cvAndManifestoPdf">CV and Manifesto Pdf</Label>{' '}
                                <CyderFileUpload
                                    attachmentId={this.state.data.cvAndManifestoPdf}
                                    filename={this.state.data.cvAndManifestoPdfName}
                                    onUploadSuccess={this.onUploadSuccess}
                                    onUploadFail={this.onUploadFail}
                                />
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>

                    <hr />
                    <FlexRow between="xs">
                        <FlexCol xs={2}>
                            <Button className="ml-2 align-middle primary-btn-style" onClick={this.save}>
                                Save
                            </Button>
                        </FlexCol>
                        {this.state.data.id > 0 ? (
                            <FlexCol xs={2}>
                                <Button className="ml-2 align-middle primary-btn-style" onClick={this.removeConfirm}>
                                    Delete
                                </Button>
                            </FlexCol>
                        ) : (
                            <div />
                        )}
                    </FlexRow>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        save: data => {
            return dispatch(save(data));
        },
        update: data => {
            return dispatch(update(data));
        },
        remove: id => {
            return dispatch(remove(id));
        },
        load: id => {
            return dispatch(load(id));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(AddPage));
